/** Ad-spend API calls (typed). */

import { apiDelete, apiGet, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiAdSpend } from "./adspend.adapter";

export interface AdSpendListParams {
  page?: number;
  limit?: number;
  search?: string;
  platform?: string;
  source?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const adSpendApi = {
  list: (params: AdSpendListParams = {}) =>
    apiGet<PaginatedResponse<ApiAdSpend>>("/ad-spend", params as QueryParams),
  create: (body: Record<string, unknown>) => apiPost<ApiAdSpend>("/ad-spend", body),
  archive: (id: string) => apiDelete<ApiAdSpend>(`/ad-spend/${id}`),
  restore: (id: string) => apiPost<ApiAdSpend>(`/ad-spend/${id}/restore`),
};
